export const LandingPageRoutes = [
    {
        path: '',
        name: 'home',
        component: () => import('@/views/Home.vue'),
    },
    {
        path: 'pricing',
        name: 'pricing',
        component: () => import('@/views/Pricing.vue'),
    },
    {
        path: 'about',
        name: 'about',
        component: () => import('@/views/AboutUs.vue'),
    },
    {
        path: 'terms',
        name: 'terms',
        component: () => import('@/views/TermsOfUse.vue'),
    },
    {
        path: 'press',
        name: 'press',
        component: () => import('@/views/Press.vue'),
    },
    {
        path: 'contact-us',
        name: 'contact-us',
        component: () => import('@/views/ContactUs.vue'),
    },
    {
        path: 'features',
        name: 'features',
        component: () => import('@/views/Features.vue'),
    },
    {
        path: 'merchants',
        name: 'merchants',
        component: () => import('@/views/Merchants.vue'),
    },
    {
        path: 'grab-integration',
        name: 'grab-integration',
        component: () => import('@/views/GrabExpress.vue'),
    },
    {
        path: 'sales-partner',
        name: 'sales-partner',
        redirect: { name: 'sales-partner-index' },
        component: () => import('@/views/Wrapper.vue'),
        children: [
            {
                path: '',
                name: 'sales-partner-index',
                component: () => import('@/views/SalesPartner.vue'),
            },
            {
                path: 'get-started',
                name: 'sales-partner-get-started',
                component: () => import('@/views/SalesPartnerGetStarted.vue'),
            },
        ],
    },
    {
        path: 'bpi-integration',
        name: 'bpi-integration',
        component: () => import('@/views/BpiIntegration.vue'),
    },
    {
        path: 'gcash-integration',
        name: 'gcash-integration',
        component: () => import('@/views/GCashIntegration.vue'),
    },
    {
        path: '/sales',
        name: 'sales',
        component: () => import('@/views/Sales.vue'),
    },
    {
        path: '/newsletter-subscribed',
        name: 'newsletter-subscribed',
        component: () => import('@/views/v2/NewsLetterSubscriptionSuccess.vue'),
    },
    {
        path: '/team',
        name: 'team',
        component: () => import('@/views/Team.vue'),
    },
];
